import StandardsList from "./standardsList";
import ResourceResults from "./../resources/resourceResults";

export default function StandardsContainer(props){

    const { data, publisherFilter, setResults, results, standard, setStandard, setGeneratingResults, generatingResults, setResourceSelected } = props;


    return(
        <div className="map__boxes">
         
            {data && <StandardsList publisherFilter={publisherFilter} setPageResults={setResults} data={data} standard={standard} setStandard={setStandard} generatingResults={generatingResults} setGeneratingResults={setGeneratingResults}/>}
            <div className="map__results">
                <ResourceResults generatingResults={generatingResults} results={results} setResourceSelected={setResourceSelected} />
            </div>
      </div>
    )

}